import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconMicrophone } from "@tabler/icons-react"
import LofiBrowserFrame from "@love-irish/core-lofi-browser-frame"
import BaseListItem from "../base"

export interface PodcastListItemProps {
  item: Record<string, any>
  className?: string
  footer?: React.ReactNode
  showActions?: boolean
}

export const PodcastListItem: React.FC<PodcastListItemProps> = ({
  item,
  className,
  footer,
  showActions = true,
}) => (
  <BaseListItem
    item={item}
    footer={footer}
    showActions={showActions}
    className={className}
    typeIcon={IconMicrophone}
    typeLabel="Podcast"
    testId="podcast-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.LISTEN }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <LofiBrowserFrame className="m-0!">
          <div className="col-span-4">
            <a href={item.path} className="relative block">
              {/* Mic overlay hints the podcast is playable. */}
              <IconMicrophone className="absolute top-1/2 left-1/2 -translate-1/2 text-white/80" />
              <img loading="lazy"
                src={item.thumbnailUrl || item.imageUrl}
                alt={item.name}
                className="w-[175px]"
              />
            </a>
          </div>
        </LofiBrowserFrame>
      )
    }
  />
)

export default PodcastListItem
